import { render, staticRenderFns } from "./RepayPrincipal.vue?vue&type=template&id=1b7c757d&scoped=true&"
import script from "./RepayPrincipal.vue?vue&type=script&lang=ts&"
export * from "./RepayPrincipal.vue?vue&type=script&lang=ts&"
import style0 from "./RepayPrincipal.vue?vue&type=style&index=0&id=1b7c757d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c757d",
  null
  
)

export default component.exports